if ($('#app-form-post-centro').length) {

    show_loader();

    $('#advertiser').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#campaign').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });

    $('#advertiser').on('change', function () {
        $('#campaign').html('');
        var adv_id = $('#advertiser option:selected').val();
        if (typeof adv_id !== 'undefined' && adv_id !== '') {
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/post/centro/getCampaigns/' + adv_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html = '<option></option>';
                    for (var i in data)
                        html += '<option value="' + data[i].id + '">' + data[i].name + '</option>';
                    $('#campaign').html(html);
                    $('#form_submit').attr("disabled", 'disabled');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#campaign').on('change', function () {
        $('#form_submit').attr("disabled", false);
        $('#centro_start').val('');
        $('#centro_end').val('');
        var camp_id = $('#campaign option:selected').val();
        console.log('camp_id', camp_id);
        if (typeof camp_id !== 'undefined' && camp_id !== '') {
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/post/centro/flightdates/' + camp_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('data', data);
                    $('#centro_start').val(data['start']);
                    $('#centro_end').val(data['end']);
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#post_buy_options').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div class='' style='height: 38px;'> </div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });

    $('#post_buy_stats').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-10 btn-sm select_all_columns' id='select_all_columns'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='deselect_all_columns'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div></div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });

    $('#post_buy_stats').html( $('#post_buy_stats option').sort(function(x, y) {
        return $(x).text() < $(y).text() ? -1 : 1;
    })).multiSelect('refresh');

    $('#deselect_all_columns').on('click', function(e){
        $('#post_buy_stats').multiSelect('deselect_all');
    });
    $('#select_all_columns').on('click', function(e){
        $('#post_buy_stats').multiSelect('select_all');
    });

    hide_loader();

    $('#form_submit').on('click', function () {
        var options = $('#post_buy_options option:selected').length;
        if (options > 0) {
            console.log($('#post_buy_options option:selected'));
            var stats = $('#post_buy_stats option:selected').length;
            if (stats > 0) {
                console.log($('#post_buy_stats option:selected'));
                var name = $('#post_report_name').val();
                if(name.trim() === "")
                    global_notification('warning', 'Please complete report\'s name ...');
                else if($('#centro_start').val() > $('#centro_end').val() || $('#centro_start').val() === "" || $('#centro_end').val() === "") {
                    global_notification('warning', 'Invalid flight dates range ...');
                }else{
                    show_loader();
                    $('#app-form-post-centro').submit();
                }
            } else
                global_notification('warning', 'Please select at least one report option ...');
        } else
            global_notification('warning', 'Please select at least one analysis breakout ...');

    });

}

if ($('#app-centro-post-buy-analysis').length) {
    show_loader();

    var update_floating = function(e){
        console.log("inside total");
        var total_columns = [
            'impressionsBid',
            'impressionsWon',
            'viewabilitySpend',
            'dataSpend',
            'clicks',
            'clickThroughConversions',
            'viewThroughConversions',
            'totalConversions',
            'revenue',
            'ctcRevenue',
            'vtcRevenue',
            'costPerAcquisition',
            'totalCVRM',
            'companionOfferRevenue',
            'videoStarted',
            'roas',
            'totalSpend',
            'companionImpressions',
            'companionClicks',
            'companionConversions',
            'videoFirstQuartileReached',
            'videoMidpointReached',
            'videoThirdQuartileReached',
            'videoCompleted',
        ];
        var avg_columns = [
            'winRate',
            'totalEffectiveCPM',
            'costPerClick',
            'clickThroughRate',
            'clickthruRate',
            'clickEffectiveCPA',
            'clickCVR',
            'viewCVR',
            'profitPerClick',
            'revenuePerMille',
            'videoCompletionRate',
            'mediaEffectiveCPM',
            'dataEffectiveCPM',
            'clickRPM',
        ];
        var row_count = 0;
        var totals = {};
        for (var ind in avg_columns)
            totals[avg_columns[ind]] = 0;
        for (var ind in total_columns)
            totals[total_columns[ind]] = 0;
        e.api.forEachNodeAfterFilter( function(node) {
            for (var ind in totals){
                totals[ind] = parseFloat(totals[ind]) + ((!isNaN(parseFloat(node.data[ind]))) ? parseFloat(node.data[ind]) : 0);
            }
            row_count++;
        });
        var floating_top_row1 = e.api.pinnedRowModel.pinnedTopRows[0];
        for (var ind in avg_columns) {
            floating_top_row1.data[avg_columns[ind]] = (row_count > 0) ? (parseFloat(totals[avg_columns[ind]]) / row_count) : 0;
        }
        for (var ind in total_columns) {
            floating_top_row1.data[total_columns[ind]] = totals[total_columns[ind]];
        }
        console.log('totals', totals);
        e.api.refreshCells({rowNodes: [floating_top_row1], columns: total_columns.concat(avg_columns), force: true});

    }

    $.ajax({
        type: 'GET',
        url: '/post/centro/show/' + $('#centro_analysis_id').val(),
        dataType: 'json',
        encode: true,
        success: function (data) {
            console.log('columns_header_array ', columns_header_array);

            var colDefs = [
                {
                    headerName: "Name",
                    field: "name",
                    width: 200,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
                {
                    headerName: "Preview",
                    field: "preview",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false,
                    cellRenderer: function(params) {
                        if(typeof  params.value !== 'undefined' && params.value !== '')
                            return '<a href="'+params.value+'" target="_blank">Preview</a>'
                        return '';
                    }
                },
                {
                    headerName: "Status",
                    field: "status",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
                {
                    headerName: "Format",
                    field: "format",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
                {
                    headerName: "Size",
                    field: "size",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
            ];
            var floatingColumDef = [{}];
            for(var col in columns_header_array){
                floatingColumDef[0][col] = 0;
                if(col.toLowerCase().indexOf('rpm') !== -1 || col.toLowerCase().indexOf('cpa') !== -1 || col.toLowerCase().indexOf('cost') !== -1 || col.toLowerCase().indexOf('spend') !== -1 || col.toLowerCase().indexOf('cpm') !== -1 || col.toLowerCase().indexOf('revenue') !== -1){
                      colDefs.push({
                           headerName: columns_header_array[col],
                           field: col,
                           width: 100,
                           cellStyle: {'text-align': "left"},
                           hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                           cellRenderer: function (params) {
                               return (typeof params.value !== 'undefined') ? '$' + params.value.toFixed(2) : '$0.00';
                           }
                       });

                }else if(col.toLowerCase().indexOf('rate') !== -1) {
                    colDefs.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                            cellRenderer: function (params) {
                                return (typeof params.value !== 'undefined') ? (params.value * 100).toFixed(2) + '%' : '0.00%';
                            }
                        });


                }else {
                    colDefs.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                        });


                }
            }

            var gridInvExportInfo = {
                columnDefs: colDefs,
                defaultColDef: {
                    suppressToolPanel: true
                },
                toolPanelSuppressValues: true,defaultToolPanel: '',
                pinnedTopRowData: floatingColumDef,
                pinnedBottomRowData: [],
                rowSelection: 'single',
                suppressRowClickSelection: false,
                enableColResize: true,
                //suppressMenuColumnPanel: true,
                suppressTouch: true,
                headerHeight: 30,
                suppressDragLeaveHidesColumns: true,
                enableCellChangeFlash: true,
                rowHeight: 22,
                suppressRowHoverClass: true,
                suppressParentsInRowNodes: true,
                toolPanelSuppressValues: true,
                toolPanelSuppressRowGroups: true,
                groupUseEntireRow: false,
                groupDefaultExpanded: 1,
                marryChildren: true,
                suppressAggFuncInHeader: true,
                enableFilter: true,
                enableSorting: true,
                animateRows: true,
                icons: {
                    groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                    groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                    menu: '<i class="fa fa-bars fa-lg"/>',
                    sortAscending: '<i class="fa fa-caret-down"/>',
                    sortDescending: '<i class="fa fa-caret-up"/>',
                    columnMoveMove: '<i class="fa fa-arrows"></i>',
                    columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                    columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                    columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                    columnMoveHide: '<i class="fa fa-remove"/>'
                },
                getContextMenuItems: getContextMenuInvoiceOrder,
                onFilterChanged: function (e) {
                    update_floating(e);
                    if (this.api.isAnyFilterPresent())
                        $('#tab1-reset_filters').show();
                    else
                        $('#tab1-reset_filters').hide();
                },
                onGridReady: function (e) {
                    update_floating(e);
                }
            };

            $('#myGridCreative').html('');
            gridInvExportInfo.rowData = data['row_data'];
            var gridDetCreative = document.querySelector('#myGridCreative');
            var gridCreative = new agGrid.Grid(gridDetCreative, gridInvExportInfo);

            var colDefs2 = [
                {
                    headerName: "Name",
                    field: "name",
                    width: 200,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
                {
                    headerName: "Type",
                    field: "type",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
                {
                    headerName: "Rule Status",
                    field: "ruleStatus",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },
                {
                    headerName: "Implied Status",
                    field: "impliedStatus",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },{
                    headerName: "Implied Bid",
                    field: "impliedBid",
                    width: 100,
                    cellStyle: {'text-align': "left"},
                    hide: false
                },

            ];
            var floatingColumDef2 = [{}];
            var second_column_def = [];
            for(var col in columns_header_array) {
                floatingColumDef2[0][col] = 0;
                if (col.toLowerCase().indexOf('rpm') !== -1 || col.toLowerCase().indexOf('cpa') !== -1 || col.toLowerCase().indexOf('cost') !== -1 || col.toLowerCase().indexOf('spend') !== -1 || col.toLowerCase().indexOf('cpm') !== -1 || col.toLowerCase().indexOf('revenue') !== -1) {
                    colDefs2.push({
                        headerName: columns_header_array[col],
                        field: col,
                        width: 100,
                        cellStyle: {'text-align': "left"},
                        hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                        cellRenderer: function (params) {
                            return (typeof params.value !== 'undefined') ? '$' + params.value.toFixed(2) : '$0.00';
                        }
                    });


                } else if (col.toLowerCase().indexOf('rate') !== -1) {
                    colDefs2.push({
                        headerName: columns_header_array[col],
                        field: col,
                        width: 100,
                        cellStyle: {'text-align': "left"},
                        hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                        cellRenderer: function (params) {
                            return (typeof params.value !== 'undefined') ? (params.value * 100).toFixed(2) + '%' : '0.00%';
                        }
                    });


                } else {
                    colDefs2.push({
                        headerName: columns_header_array[col],
                        field: col,
                        width: 100,
                        cellStyle: {'text-align': "left"},
                        hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                    });


                }
            }

            var gridInvExportInfo2 = {
                columnDefs: colDefs2,
                defaultColDef: {
                    suppressToolPanel: true
                },
                toolPanelSuppressValues: true,defaultToolPanel: '',
                pinnedTopRowData: floatingColumDef2,
                pinnedBottomRowData: [],
                rowSelection: 'single',
                suppressRowClickSelection: false,
                enableColResize: true,
                //suppressMenuColumnPanel: true,
                suppressTouch: true,
                headerHeight: 30,
                suppressDragLeaveHidesColumns: true,
                enableCellChangeFlash: true,
                rowHeight: 22,
                suppressRowHoverClass: true,
                suppressParentsInRowNodes: true,
                toolPanelSuppressValues: true,
                toolPanelSuppressRowGroups: true,
                groupUseEntireRow: false,
                groupDefaultExpanded: 1,
                marryChildren: true,
                suppressAggFuncInHeader: true,
                enableFilter: true,
                enableSorting: true,
                animateRows: true,
                icons: {
                    groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                    groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                    menu: '<i class="fa fa-bars fa-lg"/>',
                    sortAscending: '<i class="fa fa-caret-down"/>',
                    sortDescending: '<i class="fa fa-caret-up"/>',
                    columnMoveMove: '<i class="fa fa-arrows"></i>',
                    columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                    columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                    columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                    columnMoveHide: '<i class="fa fa-remove"/>'
                },
                getContextMenuItems: getContextMenuInvoiceOrder,
                onFilterChanged: function (e) {
                    update_floating(e);
                    if (this.api.isAnyFilterPresent())
                        $('#tab2-reset_filters').show();
                    else
                        $('#tab2-reset_filters').hide();
                },
                onGridReady: function (e) {
                    update_floating(e);
                }
            };

            $('#myGridApp').html('');
            gridInvExportInfo2.rowData = data['row_data2'];
            var gridDetApp = document.querySelector('#myGridApp');
            var gridApp = new agGrid.Grid(gridDetApp, gridInvExportInfo2);

            var colDefs3 = [
                {
                    headerName: "Name",
                    field: "name",
                    width: 200,
                    cellStyle: {'text-align': "left"},
                    hide: false
                }

            ];
            var floatingColumDef3 = [{}];

            for(var col in columns_header_array){
                floatingColumDef3[0][col] = 0;
                if(col.toLowerCase().indexOf('rpm') !== -1 || col.toLowerCase().indexOf('cpa') !== -1 || col.toLowerCase().indexOf('cost') !== -1 || col.toLowerCase().indexOf('spend') !== -1 || col.toLowerCase().indexOf('cpm') !== -1 || col.toLowerCase().indexOf('revenue') !== -1) {
                    colDefs3.push({
                        headerName: columns_header_array[col],
                        field: col,
                        width: 100,
                        cellStyle: {'text-align': "left"},
                        hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                        cellRenderer: function (params) {
                            return (typeof params.value !== 'undefined') ? '$' + params.value.toFixed(2) : '$0.00';
                        }
                    });
                }else if(col.toLowerCase().indexOf('rate') !== -1) {

                        colDefs3.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                            cellRenderer: function (params) {
                                return (typeof params.value !== 'undefined') ? (params.value * 100).toFixed(2) + '%' : '0.00%';
                            }
                        });


                }else {
                       colDefs3.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                        });


                }
            }

            var gridInvExportInfo3 = {
                columnDefs: colDefs3,
                defaultColDef: {
                    suppressToolPanel: true
                },
                toolPanelSuppressValues: true,defaultToolPanel: '',
                pinnedTopRowData: floatingColumDef3,
                pinnedBottomRowData: [],
                rowSelection: 'single',
                suppressRowClickSelection: false,
                enableColResize: true,
                //suppressMenuColumnPanel: true,
                suppressTouch: true,
                headerHeight: 30,
                suppressDragLeaveHidesColumns: true,
                enableCellChangeFlash: true,
                rowHeight: 22,
                suppressRowHoverClass: true,
                suppressParentsInRowNodes: true,
                toolPanelSuppressValues: true,
                toolPanelSuppressRowGroups: true,
                groupUseEntireRow: false,
                groupDefaultExpanded: 1,
                marryChildren: true,
                suppressAggFuncInHeader: true,
                enableFilter: true,
                enableSorting: true,
                animateRows: true,
                icons: {
                    groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                    groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                    menu: '<i class="fa fa-bars fa-lg"/>',
                    sortAscending: '<i class="fa fa-caret-down"/>',
                    sortDescending: '<i class="fa fa-caret-up"/>',
                    columnMoveMove: '<i class="fa fa-arrows"></i>',
                    columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                    columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                    columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                    columnMoveHide: '<i class="fa fa-remove"/>'
                },
                getContextMenuItems: getContextMenuInvoiceOrder,
                onFilterChanged: function (e) {
                    update_floating(e);
                    if (this.api.isAnyFilterPresent())
                        $('#tab3-reset_filters').show();
                    else
                        $('#tab3-reset_filters').hide();
                },
                onGridReady: function (e) {
                    update_floating(e);
                }
            };

            $('#myGridExchange').html('');
            gridInvExportInfo3.rowData = data['row_data3'];
            var gridDetExchange = document.querySelector('#myGridExchange');
            var gridExchange = new agGrid.Grid(gridDetExchange, gridInvExportInfo3);

            var colDefs4 = [
                {
                    headerName: "Name",
                    field: "name",
                    width: 200,
                    cellStyle: {'text-align': "left"},
                    hide: false
                }
            ];
            var floatingColumDef4 = [{}];

            for(var col in columns_header_array){
                floatingColumDef4[0][col] = 0;
                if(col.toLowerCase().indexOf('rpm') !== -1 ||col.toLowerCase().indexOf('cpa') !== -1 || col.toLowerCase().indexOf('cost') !== -1 || col.toLowerCase().indexOf('spend') !== -1 || col.toLowerCase().indexOf('cpm') !== -1 || col.toLowerCase().indexOf('revenue') !== -1){
                    colDefs4.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                            cellRenderer: function (params) {
                                return (typeof params.value !== 'undefined') ? '$' + params.value.toFixed(2) : '$0.00';
                            }
                        });

                }else if(col.toLowerCase().indexOf('rate') !== -1) {
                         colDefs4.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                            cellRenderer: function (params) {
                                return (typeof params.value !== 'undefined') ? (params.value * 100).toFixed(2) + '%' : '0.00%';
                            }
                        });

                }else {
                       colDefs4.push({
                            headerName: columns_header_array[col],
                            field: col,
                            width: 100,
                            cellStyle: {'text-align': "left"},
                            hide: (data['columns'].indexOf(col)) !== -1 ? false : true,
                        });


                }
            }

            var gridInvExportInfo4 = {
                columnDefs: colDefs4,
                defaultColDef: {
                    suppressToolPanel: true
                },
                toolPanelSuppressValues: true,defaultToolPanel: '',
                pinnedTopRowData: floatingColumDef4,
                pinnedBottomRowData: [],
                rowSelection: 'single',
                suppressRowClickSelection: false,
                enableColResize: true,
                //suppressMenuColumnPanel: true,
                suppressTouch: true,
                headerHeight: 30,
                suppressDragLeaveHidesColumns: true,
                enableCellChangeFlash: true,
                rowHeight: 22,
                suppressRowHoverClass: true,
                suppressParentsInRowNodes: true,
                toolPanelSuppressValues: true,
                toolPanelSuppressRowGroups: true,
                groupUseEntireRow: false,
                groupDefaultExpanded: 1,
                marryChildren: true,
                suppressAggFuncInHeader: true,
                enableFilter: true,
                enableSorting: true,
                animateRows: true,
                icons: {
                    groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                    groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                    menu: '<i class="fa fa-bars fa-lg"/>',
                    sortAscending: '<i class="fa fa-caret-down"/>',
                    sortDescending: '<i class="fa fa-caret-up"/>',
                    columnMoveMove: '<i class="fa fa-arrows"></i>',
                    columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                    columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                    columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                    columnMoveHide: '<i class="fa fa-remove"/>'
                },
                getContextMenuItems: getContextMenuInvoiceOrder,
                onFilterChanged: function (e) {
                    update_floating(e);
                    if (this.api.isAnyFilterPresent())
                        $('#tab4-reset_filters').show();
                    else
                        $('#tab4-reset_filters').hide();

                },
                onGridReady: function (e) {
                    update_floating(e);
                }
            };

            $('#myGridOffer').html('');
            gridInvExportInfo4.rowData = data['row_data4'];
            var gridDetOffer = document.querySelector('#myGridOffer');
            var gridOffer = new agGrid.Grid(gridDetOffer, gridInvExportInfo4);

            hide_loader();

           $('.export_report').on('click', function(){
               var type = $(this).attr('data-type');

               var grid = '';
               var html = '';

               if($(this).attr('data-tab') == 'creative') {
                   grid = gridInvExportInfo;
                   $('#grid_tab_hidden_type').val('creative');
                   if(type == 'pdf') {
                       var columns = [];
                       $('#tab1-hide_show_columns a').each(function () {
                           if (!$(this).hasClass('hidden-column') && $(this).html() != 'Preview')
                               columns[$(this).attr('data-col')] = $(this).html();
                       });
                       for (var i in columns)
                           html += '<option value="' + i + '"> ' + columns[i] + ' </option>';
                   }

               }
               if($(this).attr('data-tab') == 'domain') {
                   grid = gridInvExportInfo2;
                   $('#grid_tab_hidden_type').val('domain');
                   if(type == 'pdf') {
                       var columns = [];
                       $('#tab2-hide_show_columns a').each(function () {
                           if (!$(this).hasClass('hidden-column'))
                               columns[$(this).attr('data-col')] = $(this).html();
                       });
                       for (var i in columns)
                           html += '<option value="' + i + '"> ' + columns[i] + ' </option>';
                   }
               }
               if($(this).attr('data-tab') == 'exchange') {
                   grid = gridInvExportInfo3;
                   $('#grid_tab_hidden_type').val('exchange');
                   if(type == 'pdf') {
                       var columns = [];
                       $('#tab3-hide_show_columns a').each(function () {
                           if (!$(this).hasClass('hidden-column'))
                               columns[$(this).attr('data-col')] = $(this).html();
                       });
                       for (var i in columns)
                           html += '<option value="' + i + '"> ' + columns[i] + ' </option>';
                   }
               }
               if($(this).attr('data-tab') == 'offer') {
                   grid = gridInvExportInfo4;
                   $('#grid_tab_hidden_type').val('offer');
                   if(type == 'pdf') {
                       var columns = [];
                       $('#tab4-hide_show_columns a').each(function () {
                           if (!$(this).hasClass('hidden-column'))
                               columns[$(this).attr('data-col')] = $(this).html();
                       });
                       for (var i in columns)
                           html += '<option value="' + i + '"> ' + columns[i] + ' </option>';
                   }
               }
               if(type !== 'pdf')
                 export_report_function(type, grid)
               else {
                    $('#grid_tab_hidden').val(grid);
                    $('#selected_columnn_pdf').multiSelect({
                       selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                       selectionHeader: "<div style='height: 38px;'></div>",
                       afterInit: function(ms){
                           var that = this,
                               $selectableSearch = that.$selectableUl.prev(),
                               selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                           that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                               .on('keydown', function(e){
                                   if (e.which === 40){
                                       that.$selectableUl.focus();
                                       return false;
                                   }
                               });
                       },
                       afterSelect: function(values){
                           this.qs1.cache();
                           form_curr_dayparts = this.$element.val();
                           if(this.$element.val().length <= 10){

                           }else{
                               this.$element.multiSelect('deselect', values);
                               form_curr_dayparts = this.$element.val();

                               swal({
                                       title: "Warning",
                                       text: "The max number is 10 ...",
                                       type: "warning",
                                       showCancelButton: true,
                                       confirmButtonClass: "btn-danger",
                                       confirmButtonText: "OK",
                                       cancelButtonText: "Close",
                                       closeOnConfirm: true,
                                       closeOnCancel: true
                                   },
                                   function (isConfirm) {

                                   });
                           }

                           if(form_curr_dayparts.length < 10){
                               this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 10)').removeClass('text-warning').addClass('text-muted');
                           }else{
                               this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 10)').removeClass('text-muted').addClass('text-warning');
                           }
                       },
                       afterDeselect: function(values){
                           this.qs1.cache();

                           form_curr_dayparts = this.$element.val();


                           this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 10)').removeClass('text-warning').addClass('text-muted');
                       }
                   });
                    $('#selected_columnn_pdf').html(html);
                       $('#selected_columnn_pdf').html( $('#selected_columnn_pdf option').sort(function(x, y) {
                           console.log('x ', $(x).text());
                           console.log('y ', $(y).text());
                           console.log('...... ', $(x).text() < $(y).text() ? -1 : 1);
                           return $(x).text().trim() < $(y).text().trim() ? -1 : 1;
                       })).multiSelect('refresh');

                  //  var options = $('#selected_columnn_pdf option');
                  //  var arr = options.map(function(_, o) {
                  //      return {
                  //          t: $(o).text(),
                  //          v: o.value
                  //      };
                  //  }).get();
                  //  arr.sort(function(o1, o2) {
                  //      return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
                  //  });
                  //  options.each(function(i, o) {
                  //      console.log(i);
                  //      o.value = arr[i].v;
                  //      $(o).text(arr[i].t);
                  //  });
                  //  console.log('arr >>>', arr);
                  //  console.log('options >>>', options);
                  // // $('#selected_columnn_pdf option').html()
                       $('#ExportPDFModal').modal('show');
               }
           });
           $('#submit_export_pdf').on('click', function(){
               show_overlay_loader($('#ExportPDFModal .modal-content'));
               var grid = '';
               if($('#grid_tab_hidden_type').val() == 'creative')
                   grid = gridInvExportInfo;
               else if($('#grid_tab_hidden_type').val() == 'domain')
                   grid = gridInvExportInfo2;
               else if($('#grid_tab_hidden_type').val() == 'exchange')
                   grid = gridInvExportInfo3;
               else
                   grid = gridInvExportInfo4;
               var params = {
                   tab_type : $('#grid_tab_hidden_type').val(),
                   columns : $('#selected_columnn_pdf').val(),
                   top_line: grid.api.pinnedRowModel.pinnedTopRows[0].data,
                   report_id: new_report.id,
               };

               console.log('params ***** ', params);
               $.ajax({
                   type: 'POST',
                   headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                   url: '/post-buy/centro/export/pdf/save',
                   data: JSON.stringify(params),
                   contentType: "application/json",
                   dataType: 'json',
                   encode: true,
                   success: function (response) {
                       window.open(response.new_tab_target);
                       hide_overlay_loader($('#ExportPDFModal .modal-content'))
                   },
                   error: function (xhr) {
                       debug(xhr.responseText);
                       hide_overlay_loader($('#ExportPDFModal .modal-content'))
                   }
               });
            });
           function export_report_function(format, gridOptions){
               var params = {
                   skipHeader: false,
                   columnGroups: (format == "csv") ? false : true,
                   skipFooters: false,
                   skipGroups: false,
                   skipPinnedTop: false,
                   skipPinnedBottom: false,
                   allColumns: false,
                   onlySelected: false,
                   suppressQuotes: false,
                   fileName: "report." + format,

               };
               if (format === 'csv') {
                   params.customHeader = [
                       [
                           "Basis Post Buy Report: \n"
                       ],
                       [
                           "Advertiser: " + advertiser.name + "\n"
                       ],
                       [
                           "Campaign: " + campaign.name + "\n"
                       ],
                       [
                           "Flight Dates : " + fd_rep + "\n"
                       ],
                       [
                           "Created At: " + created_at_repo + "\n"
                       ],

                   ];
               }else {
                   params.customHeader = [
                       [],
                       [
                           {data: {type: 'String', value: 'Basis Post Buy Report'}},
                           {data: {type: 'String', value: ""}},
                       ],
                       [
                           {data: {type: 'String', value: 'Advertiser: '}},
                           {data: {type: 'String', value: advertiser.name}},
                       ],
                       [
                           {data: {type: 'String', value: 'Campaign: '}},
                           {data: {type: 'String', value: campaign.name}},
                       ],
                       [
                           {data: {type: 'String', value: 'Flight Dates: '}},
                           {data: {type: 'String', value: fd_rep}},
                       ],
                       [
                           {data: {type: 'String', value: 'Created At: '}},
                           {data: {type: 'String', value: created_at_repo}},
                       ],
                       [],
                   ];
               }

               params.processCellCallback = function (params) {

                   if (params.column.colId.toLowerCase().indexOf('rpm') !== -1 || params.column.colId.toLowerCase().indexOf('cpa') !== -1 || params.column.colId.toLowerCase().indexOf('cost') !== -1 || params.column.colId.toLowerCase().indexOf('spend') !== -1 || params.column.colId.toLowerCase().indexOf('cpm') !== -1 || params.column.colId.toLowerCase().indexOf('revenue') !== -1) {
                       return parseFloat(params.value).toLocaleString("en-US", {
                           style: "currency",
                           currency: "USD",
                           minimumFractionDigits: 2
                       });
                   }
                   else if (params.column.colId.toLowerCase().indexOf('rate') !== -1) {
                       return parseFloat(params.value).toLocaleString("en-US", {
                           style: "decimal",
                           minimumFractionDigits: 2,
                           maximumFractionDigits: 2,
                       }) + '%';

                   }
                   else
                       return params.value;

               };
               if (format === 'csv') {
                   console.log("-------------csv-----------------");
                   gridOptions.api.exportDataAsCsv(params);
               } else {
                   console.log("-------------excel-----------------");
                   var content = gridOptions.api.getDataAsExcel(params);
                   var workbook = XLSX.read(content, {type: 'binary'});
                   var xlsxContent = XLSX.writeFile(workbook, 'report.xlsx', {bookType: 'xlsx', type: 'base64'});
               }
           }

            //first tab hide/show list
             var html_1 = '<li><a data-col="preview" class="preview">Preview</a></li>' +
                '                                                <li><a data-col="status" class="ruleStatus"> Status</a></li>' +
                '                                                <li><a data-col="format" class="impliedStatus">Format</a></li>' +
                '                                                <li><a data-col="size" class="impliedBid">Size</a></li>';
            var html_2 = '';
            for(var i in columns_header_array)
                html_2 += '<li><a data-col="'+ i +'" class="'+ i +'"> '+ columns_header_array[i] +' </a></li>';
            $('#tab1-hide_show_columns').html(html_1 + html_2);

           //second tab hide/show list
               var html_1 = '<li><a data-col="type" class="type" >Type</a></li>' +
                '                                                <li><a data-col="ruleStatus" class="ruleStatus">Rule Status</a></li>' +
                '                                                <li><a data-col="impliedStatus" class="impliedStatus">Implied Status</a></li>' +
                '                                                <li><a data-col="impliedBid" class="impliedBid">Implied Bid</a></li>';

            $('#tab2-hide_show_columns').html(html_1 + html_2);

            //third tab hide/show list
            $('#tab3-hide_show_columns').html(html_2);

            //four tab hide/show list
            $('#tab4-hide_show_columns').html(html_2);


            $('.hide_show_columns a').each( function (){
                var not_sel = ['preview', 'format', 'size', 'status', 'type', 'ruleStatus', 'impliedStatus', 'impliedBid'];
                var attr = $(this).attr('data-col');
                if(not_sel.indexOf(attr) == -1 && data['columns'].indexOf(attr) == -1) {
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                }
            });

            $('.hide_show_columns a').on('click', function(e){
                var tab =  $(this).parent().parent().attr('id');
                var attr = $(this).attr('data-col');
                var grid= '';
                if(tab == 'tab1-hide_show_columns')
                    grid = gridInvExportInfo;
                if(tab == 'tab2-hide_show_columns')
                    grid = gridInvExportInfo2;
                if(tab == 'tab3-hide_show_columns')
                    grid = gridInvExportInfo3;
                if(tab == 'tab4-hide_show_columns')
                    grid = gridInvExportInfo4;

                if ($(this).hasClass('hidden-column') ) {
                    grid.columnApi.setColumnsVisible([attr], true);
                    $(this).removeClass('hidden-column');
                    $(this).css('background-color', 'white');
                } else {
                    grid.columnApi.setColumnsVisible([attr], false);
                    $(this).addClass('hidden-column');
                    $(this).css('background-color', '#CCCCCC');
                    if($(this).attr('data-ac') == 'excel') {
                        $(this).removeClass('hidden-column');
                        $(this).css('background-color', 'white');
                    }
                }
                e.stopPropagation();
            });

            //Reset filter
            $('.reset_filters').on('click', function () {
                if($(this).attr('id') == 'tab1-reset_filters')
                    var grid = gridInvExportInfo;
                if($(this).attr('id') == 'tab2-reset_filters')
                    var grid = gridInvExportInfo2;
                if($(this).attr('id') == 'tab3-reset_filters')
                    var grid = gridInvExportInfo3;
                if($(this).attr('id') == 'tab4-reset_filters')
                    var grid = gridInvExportInfo4;
                $.each(grid.api.getFilterModel(), function (index, value) {
                    grid.api.destroyFilter(index);
                });
            });
        },
        error: function (xhr) {
            hide_loader();
            ajax_error();
            debug(xhr.responseText);
        }
    });

}
